import { render } from "./FormRadioButtonsTextHtmlFieldComponent.vue?vue&type=template&id=0d97db93&scoped=true"
import script from "./FormRadioButtonsTextHtmlFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioButtonsTextHtmlFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioButtonsTextHtmlFieldComponent.vue?vue&type=style&index=0&id=0d97db93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d97db93"]])

export default __exports__